import { store } from './store/index';
// const Home = () => import(/* webpackChunkName: "home-chunk" */ './ui/layout/pages/Home.vue');
const Results = () => import(/* webpackChunkName: "results-chunk" */ './ui/layout/pages/Results.vue');
import Home from './ui/layout/pages/Home.vue';
// import Results from './ui/layout/pages/Results.vue';

async function requireAuth(to,from,next) {
	// http://192.168.1.227:8383/#/reset?u=1773&t=NAzQ4Lw7V0+SDnJqBNd4kg==
	console.log('requireAuth: ', to,from,next);
	let isAuthenticated = await store.dispatch('initUser');
	let categories = store.state.categories;

	//alert("init settings now");
	

	console.log("isAuthenticated > ", isAuthenticated);
	if (!categories) {
		store.dispatch('initCategories');
	}
	if (!isAuthenticated) {
		/(login||reset)/.test(to.name)
		? next()
		: next({ path: '/login', name: 'login'})
  	} else {
		let items = store.state.items;
		if (!items || items==='loading') {
			store.dispatch('initItems');
		}
		to.name==='login'
		? next({name:'home'})
    	: next()
  	}
}

const routes = [
	// ITEM RESULTS GRID PAGE
	{
		path: '/categories',
		component: Results,
		children: [
		{
			path:':category',
			name: 'results-root',
			children: [
					{
						path:':subcat',
						name: 'results-child',
						children: [
							{
								path:':grandchildFilter',
								name: 'results-grandchild'
							},
						]
					}
				]			
			},
		],
		beforeEnter: requireAuth
	},
	{
		path: '/results/:searchFilter',
		name: 'results-search',
		component: Results,
		beforeEnter: requireAuth
	},
	{ path: '/login', component:Home, name: 'login', beforeEnter: requireAuth},
	{ path: '/reset', component:Home, name: 'reset', beforeEnter: requireAuth},
	// MENU PAGES
	{
		path: '/:category',
		component: Home, name: 'sub-menu', beforeEnter: requireAuth,
		children: [
			{
				path: ':subcat',
				name: 'sub-menu2'
			}
		]
	},
	{ path: '/all', component:Results, name: 'all', beforeEnter: requireAuth},
	
	/* home old */
	 { path: '/', component:Home, name: 'home', beforeEnter: requireAuth}, 
	{ path: '*', redirect: { name: 'home' } } 
	
	 /* home new, this will show the new items 
 	{ path: '/', redirect: { path: '/categories/New' } },
	{ path: '*', redirect: { path: '/categories/New' } }
	*/

 	]


export default {
	root: '/',
	routes
	// mode: 'history'
}